import React from 'react';
import { Image, Video, Calendar } from 'lucide-react';
import { getImageUrl } from '../../utils/imageUtils.js';

const statusStyles = {
  pending: { labelEn: 'Pending', labelNe: 'समीक्षामा', class: 'bg-amber-50 text-amber' },
  approved: { labelEn: 'Approved', labelNe: 'स्वीकृत', class: 'bg-primary-100 text-primary' },
  rejected: { labelEn: 'Rejected', labelNe: 'अस्वीकृत', class: 'bg-error-50 text-error' },
};

const MediaPreviewCard = ({ media, language }) => {
  const status = statusStyles[media.status] || statusStyles.pending;
  const fileUrl = getImageUrl(media.fileUrl || media.image);
  const uploadDate = media.createdAt
    ? new Date(media.createdAt).toLocaleDateString('ne-NP')
    : media.uploadDate || '—';

  return (
    <div className="group rounded-3xl border border-char-100 bg-white shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-card-hover">
      <div className="relative flex aspect-[16/10] items-center justify-center overflow-hidden rounded-t-3xl bg-char-50">
        {fileUrl ? (
          media.fileType === 'video' || media.type === 'video' ? (
            <video
              src={fileUrl}
              className="h-full w-full object-cover"
              muted
              playsInline
            />
          ) : (
            <img
              src={fileUrl}
              alt={media.caption}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          )
        ) : (
          <div className="flex flex-col items-center gap-2 text-char-300">
            {(media.fileType === 'video' || media.type === 'video') ? <Video size={32} /> : <Image size={32} />}
            <span className="text-xs font-semibold">
              {(media.fileType === 'video' || media.type === 'video') ? 'Video' : 'Image'}
            </span>
          </div>
        )}
        <span
          className={`absolute right-3 top-3 rounded-full px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider shadow-sm ${status.class}`}
        >
          {language === 'ne' ? status.labelNe : status.labelEn}
        </span>
      </div>

      <div className="p-4">
        <p className="mb-2 text-sm font-bold text-char-900 line-clamp-2">{media.caption}</p>
        <div className="space-y-1.5">
          {media.relatedEvent && (
            <div className="flex items-center gap-2 text-xs text-char-400">
              <Calendar size={12} />
              <span className="line-clamp-1">{media.relatedEvent}</span>
            </div>
          )}
          <div className="flex items-center gap-2 text-xs text-char-400">
            <Calendar size={12} />
            <span>{uploadDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaPreviewCard;
